import { render, staticRenderFns } from "./PersistSupportedServerView.vue?vue&type=template&id=503a6ad8"
import script from "./PersistSupportedServerView.vue?vue&type=script&lang=ts"
export * from "./PersistSupportedServerView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports